import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { UserPermissionDto, ResponseDto } from "@mimber/schema"
import { memberPermissionsKeys } from "../roles.utils"

/**
 * Organization-specific hook for fetching a member's direct permissions
 * Can only be used in mimber-organization app
 */
export const useMemberPermissions = (
  memberUuid: string,
  options?: UseQueryOptions<ResponseDto<UserPermissionDto[]>, Error>
): UseQueryResult<ResponseDto<UserPermissionDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useMemberPermissions")

  const { server } = useServerContext()

  return useQuery({
    queryKey: memberPermissionsKeys.findByMember(memberUuid),
    queryFn: async () => {
      const response = await server.get<ResponseDto<UserPermissionDto[]>>(
        `members/${memberUuid}/permissions`
      )
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!memberUuid,
    ...options,
  })
}
